import { gql } from '@apollo/client'

export const GET_CONFLICT = gql`
  query GetConflict($execution_id: Int) {
    conflict(execution_id: $execution_id) {
      start_time_changed {
        from
        to
      }
      options {
        option
        text
        conflicts {
          worker_id
          worker_name
          reason_text
        }
      }
    }
  }
`
